import { render } from "./ActivityLog.vue?vue&type=template&id=bb076eb0&scoped=true"
import script from "./ActivityLog.vue?vue&type=script&lang=js"
export * from "./ActivityLog.vue?vue&type=script&lang=js"

import "./ActivityLog.vue?vue&type=style&index=0&id=bb076eb0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb076eb0"]])

export default __exports__